<!--资环行动-视频新闻-->
<template class="carbon">
  <div style="font-family: Alibaba">
    <!--CP端-->
    <div class="PC_box">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component class="act" :is='components.tail'></component>
        </keep-alive>
      </div>

      <!--导航图-->
      <div style="margin-bottom:80px">
        <el-carousel height="25vw" class='carousel_class'>
          <el-carousel-item v-for='item in zhVideoList' :key='item.id'>
            <div @click='jump(item)'>
              <el-image
                style="width: 100%;height: 25vw"
                v-if="item.fullPathUrl != null"
                :src="item.fullPathUrl"
              />
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <!--视频-->
      <div class="video_box">
        <h4>{{ videoHome.title }}</h4>
        <p>{{ videoHome.releaseTime }}</p>
        <video
          controls
          :src="videoHome.fullPathUrl != null ? videoHome.fullPathUrl : ''"
          style="width: 100%; height: auto;"></video>
      </div>

      <!--视频列表标题-->
      <div class='title'>
        <div>
          <h1>
            <i class="el-icon-caret-right"></i>{{ cnNameOne }}
          </h1>
          <p>{{ enNameOne }}</p>
        </div>
      </div>

      <!--视频列表-->
      <el-card class="box-width news" shadow="hover" style="margin-bottom: 10px !important;" v-for="item in videoListAll"  :key="item.id">
        <div class="text_item">
          <a href="#" @click='handleVideoDetail(item.id)'>
            <h4>{{item.title}}</h4>
            <p>{{item.releaseTime}}</p>
            <span class="text">{{item.briefIntroduction}}</span>
          </a>
        </div>
      </el-card>
      <!--分页-->
      <div class="box-width">
        <!--分页-->
        <div class="box-width">
          <el-pagination style="text-align: right"
                         small
                         layout="prev, pager, next"
                         next-text="下一页"
                         prev-text="上一页"
                         v-show="total>0"
                         @prev-click='upPage'
                         @next-click='upPage'
                         @current-change='upPage'
                         :total='total'
                         :page.sync='queryParams.pageNum'
                         :page-size="queryParams.pageSize"
          >
          </el-pagination>
        </div>
      </div>

      <!--插入尾部-->
      <div>
        <keep-alive>
          <component  :is='components.tail1'></component>
        </keep-alive>
      </div>
    </div>

    <!--手机端-->
    <div class="mobile_box product">
      <!--插入头部-->
      <div>
        <keep-alive>
          <component :is='components.tail'></component>
        </keep-alive>
      </div>

      <div class='paddingS'>
        <!--占位div-->
        <div style='height: 72px'></div>

        <!--视频-->
        <div class="video_box" style="background: #fff">
          <h4>{{ videoHome.title }}</h4>
          <p>{{ videoHome.releaseTime }}</p>
          <video
            controls
            :src="videoHome.fullPathUrl != null ? videoHome.fullPathUrl : ''"
            style="width: 100%; height: auto;"></video>
        </div>

        <!--视频列表-->
        <el-card class="box-width news" shadow="hover" style="margin-bottom: 10px !important;" v-for="item in videoListAll" :key="item.id">
          <div class="text_item">
            <a href="#" @click='handleVideoDetail(item.id)'>
              <h4>{{ item.title }}</h4>
              <p>{{ item.releaseTime }}</p>
              <span class="text">{{item.briefIntroduction}}</span>
            </a>
          </div>
        </el-card>
        <!--分页-->
        <div class="box-width">
          <el-pagination style="text-align: right"
                         small
                         layout="prev, pager, next"
                         next-text="下一页"
                         prev-text="上一页"
                         v-show="total>0"
                         @prev-click='upPage'
                         @next-click='upPage'
                         @current-change='upPage'
                         :total='total'
                         :page.sync='queryParams.pageNum'
                         :page-size="queryParams.pageSize"
          >
          </el-pagination>
        </div>
        <!--插入尾部-->
        <div>
          <keep-alive>
            <component  :is='components.tail1'></component>
          </keep-alive>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import header from '../components/header.vue'
import footer from '../components/footer.vue'
import { findBanner, findEnName, getVideoHome, getVideoList } from '@/api/zh'

export default {
  data () {
    return {
      tabId: null,
      components: {
        tail: header,
        tail1: footer
      },
      enNameOne: '',
      cnNameOne: '',
      zhVideoList: [],
      player: null,
      options: {
        controls: true,
        poster: '',
        preload: 'auto'
        // 其他video.js选项...
      },
      fit: 'cover',
      url1: require('@assets/images/index/chanping1.png'),
      url: require('@assets/images/index/chanping.png'),
      url2: require('@assets/images/index/chanping2.png'),
      queryParams: {
        cnEnNameId: null,
        pageNum: 1,
        pageSize: 10
      },
      videoHome: {},
      videoListAll: [],
      total: 0,
      cnEnNameId: null
    }
  },
  created () {
    this.tabId = this.$route.query.tabId
    this.selectBanner()
    this.selectEnName()
  },
  mounted () {
  },
  beforeDestroy () {
    if (this.player) {
      this.player.dispose()
    }
  },
  methods: {
    jump (raw) {
      if (raw.newsId === undefined || raw.newsId === '' || raw.newsId === null) {
      } else {
        this.$router.push({
          path: '/textContent',
          query: {
            id: raw.newsId,
            type: 2
          }
        })
      }
    },
    /** 轮播图 */
    selectBanner () {
      let that = this
      findBanner(this.tabId).then(res => {
        that.zhVideoList = res.data
      })
    },
    /** 查询英文名称 */
    selectEnName () {
      let that = this
      findEnName(this.tabId).then(res => {
        that.enNameOne = res.data[0].enName
        that.cnNameOne = res.data[0].cnName
        that.selectVideoHome(res.data[0].id)
        that.cnEnNameId = res.data[0].id
        that.selectVideoAll(res.data[0].id)
      })
    },

    async selectVideoHome (cnEnNameId) {
      let that = this
      await getVideoHome(cnEnNameId).then(res => {
        that.videoHome = res.data
      })
    },

    async selectVideoAll (cnEnNameId) {
      let that = this
      this.queryParams.cnEnNameId = cnEnNameId
      await getVideoList(this.queryParams).then(res => {
        that.total = res.total
        that.videoListAll = res.rows
      })
    },
    /** 视频详情 */
    handleVideoDetail: function (id) {
      this.$router.push({
        path: '/videoDetails',
        query: {
          videoId: id
        }
      })
    },
    /** tab */
    handleClick (tab, event) {
      console.log(tab, event)
    },
    onSubmit () {
      console.log('submit!')
    },
    upPage (raw) {
      this.queryParams.pageNum = raw
      this.selectVideoAll(this.cnEnNameId)
    }
  }
}
</script>
